// API configuration
export const API_BASE_URL = import.meta.env.PROD
  ? "https://dishsnap-api.codorders.workers.dev"
  : "";

export function apiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}

// Get auth token from localStorage
export function getAuthToken(): string | null {
  return localStorage.getItem("dishsnap_auth_token");
}

// Create headers with auth token
export function authHeaders(additionalHeaders: Record<string, string> = {}): Record<string, string> {
  const token = getAuthToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...additionalHeaders,
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

// Authenticated fetch helper
export async function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getAuthToken();
  const headers = new Headers(options.headers);

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(url, {
    ...options,
    headers,
  });
}
